import styled from '@emotion/styled';

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const KeyDisplay = styled.code`
  display: inline-block;
  background: ${({ theme }) => theme.colors.gray100 || '#f5f5f5'};
  padding: 8px 16px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
  margin: 8px 0 16px 0;
`;

export const NewKeyAlert = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.colors.green100 || '#e6f7e6'};
  border: 1px solid ${({ theme }) => theme.colors.green || '#52c41a'};
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const NewKeyValue = styled.code`
  display: block;
  font-family: monospace;
  font-size: 14px;
  background: ${({ theme }) => theme.colors.white};
  padding: 12px;
  border-radius: 4px;
  margin: 12px 0;
  word-break: break-all;
  border: 1px solid ${({ theme }) => theme.colors.gray200 || '#ddd'};
`;

export const WarningText = styled.p`
  color: ${({ theme }) => theme.colors.orange || '#fa8c16'};
  font-size: 14px;
  margin: 8px 0;
`;

export const InfoText = styled.p`
  color: ${({ theme }) => theme.colors.gray600 || '#666'};
  font-size: 14px;
  margin: 4px 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;
